import React from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import styles from '../DataExtractionTemplate.module.scss';
import sectionTitleStyles from './SectionTitle.module.scss';
import { InterventionWizardInterface } from './InterventionsPanel/InterventionWizardProvider';
import { interventionsPendoKeys } from './InterventionsPanel/InterventionsWizardData';
import {
  Button,
  AccordionGroup,
  AccordionHeader,
  AccordionContent,
  AccordionControls,
  Heading,
  Text,
} from 'components/core';

type Props = {
  title: string;
  subTitle: string;
  wizard?: InterventionWizardInterface; // Extend to Outcomes wizard when that is ready
  children: React.ReactElement;
};

export const TemplateSection = ({
  title,
  subTitle,
  wizard,
  children,
}: Props) => {
  const shouldRenderAsAccordion = !wizard?.shouldForceWizardUse;
  const {
    formState: { isValid },
  } = useFormContext();

  return shouldRenderAsAccordion ? (
    <AccordionGroup className={styles.TemplateAccordionGroup}>
      <AccordionHeader
        className={styles.TemplateAccordionHeader}
        chevronPosition="right"
        disabled={!isValid}
      >
        <div
          className={classNames({
            [styles.HeaderContent]: true,
            [styles.HasHeaderButtons]: wizard?.showHeaderButtons,
          })}
        >
          <Heading
            type="h4"
            component="h3"
            variant="brand"
            className={sectionTitleStyles.Title}
            id={title.toLowerCase().replace(/ /g, '_')}
          >
            <div>{title}</div>
          </Heading>
          <div className={styles.SubTitle}>{subTitle}</div>
        </div>
        <AccordionControls>
          {(wizard?.showHeaderButtons && (
            <Button
              size="sm"
              type="primary"
              variant="outline"
              onClick={() => {
                wizard?.setWizardOpen(true);
              }}
              aria-label="Edit set up"
              data-pendo-key={interventionsPendoKeys.editSetup}
            >
              <Text size="sm">Edit set up</Text>
            </Button>
          )) || <></>}
          <Button
            variant="outline"
            onClick={() => undefined}
            className={styles.PreviewButton}
          >
            Preview
          </Button>
        </AccordionControls>
      </AccordionHeader>
      <AccordionContent>{children}</AccordionContent>
    </AccordionGroup>
  ) : (
    <section className={styles.SectionHeader}>
      <div className={styles.HeaderContent}>
        <Heading
          type="h4"
          component="h3"
          variant="brand"
          className={sectionTitleStyles.Title}
          id={title.toLowerCase().replace(/ /g, '_')}
        >
          <div>{title}</div>
        </Heading>
        <div className={styles.SubTitle}>{subTitle}</div>
      </div>
      <div className={styles.HeaderControls}>
        <Button type="primary" onClick={() => wizard.setWizardOpen(true)}>
          Set Up
        </Button>
      </div>
    </section>
  );
};
